import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

import * as cloudLib from 'global/lib/cloud/cloud'
import { config } from 'global/lib/config'

export default function useSignupLogic(): void {
  const location = useLocation()
  const queryParams = queryString.parse(location.search)
  // When the user comes from the other product using the ProductSwitcher, the URL will have a nav token that includes bcc account information
  const navToken = queryParams?.nav as string

  useEffect(() => {
    cloudLib.bccSignin(config.SCAN_TYPES.FORENSICS, navToken)
  }, [navToken])
}
